import { AdaptiveMenuLabel } from '@/components/ui/adaptiveMenu';
import { useCopySettings } from '@/features/copySettings';
import { CopySettingsToggles } from '@/features/copySettings/CopySettingsToggles';
import { FormattedMessage } from 'react-intl';

/**
 * Copy-settings panel rendered inside the dropdown next to the Copy button
 * when `release-scribe-improve-copy-actions` is on. Wraps the shared
 * four-toggle `CopySettingsToggles` with a labelled header. Persists to the
 * BE via `useCopySettings.updateSettings`.
 *
 * Returns `null` when the FF is off so the legacy 3-radio block in
 * `version-controller` remains the only copy UI.
 */
export const CopySettingsPanel = () => {
  const { isImprovedCopyEnabled } = useCopySettings();

  if (!isImprovedCopyEnabled) return null;

  return (
    <div data-testid="copy-settings-panel">
      <AdaptiveMenuLabel className="pb-1 text-xs font-medium text-text-secondary">
        <FormattedMessage defaultMessage="Copy settings" id="DLkMVV4+xt" />
      </AdaptiveMenuLabel>
      <div className="flex flex-col gap-0.5 py-1">
        <CopySettingsToggles />
      </div>
    </div>
  );
};
